<template>
  <div class="card-ticket-new">
    <!-- <div class="card-ticketLeft"> -->
    <div class="card-ticket-left">
      <!-- <img src=""
           alt=""> -->
      <div class="card-ticket-bg">
        <img src="../../assets/images/card-ticket/du.png" alt="">
        <!--  -->
        <p class="card-ticket-tex card-ticket-title" :title="formInline.ticketName">{{formInline.ticketName}}</p>
        <p class="card-ticket-tex card-ticket-symk" ref="syms"></p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 1">
          <span>{{formInline.startTimeStr}}</span> 至
          <span>{{formInline.endTimeStr}}</span>
        </p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 0">领券当日起
          <span> {{formInline.receiveLimitDay}} </span>天内可用</p>
        <p class="card-ticket-tex card-ticket-date" v-if="radio == 2">长期有效</p>
        <img src="../../assets/images/card-ticket/code.png" alt="" class="card-ticket-code">
        <div class="card-ticket-tex card-ticket-tips">
          <ul>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>优惠内容
              </p>
              <p class="yhContent" ref="yhtitle1" v-if="formInline.ticketType == 1 || formInline.ticketType == 2">
                <!-- {{formInline.discountContent}} -->
              </p>
              <p class="yhContent" ref="yhtitle3" v-if="formInline.ticketType == 3">
                <!-- {{formInline.discountContent}} -->
              </p>
            </li>
            <li>
              <p class="yhtitle">
                <i class="card-ticket-icon"></i>使用说明
              </p>
              <p class="yhContent" ref="yhContent">
                <!-- {{formInline.useExplain}} -->
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- </div> -->

    <div class="card-ticket-right setting-content">
      <p class="card-info">基本信息</p>
      <el-form :inline="true" :rules="rules" :model="formInline" label-width="95px" class="card-form">
        <el-form-item label="卡券类型" prop="ticketType">
          <el-select clearable v-model="formInline.ticketType" placeholder="请选择卡券类型" @change="changeType">
            <el-option v-for="(item,index) in cardTypeOptions" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="卡券名称" prop="ticketName">
          <el-input placeholder="请输入卡券名称" clearable v-model="formInline.ticketName" show-word-limit
            :maxlength="ticketNameLength" @input="descInput('name')">
          </el-input>
          <span class="cardNameYz">{{ticketName}}/{{ticketNameLength}}</span>
        </el-form-item>
        <el-form-item label="有效期" prop="isPeriodValidity">
          <div class="timeBox">
            <el-radio-group v-model="radio" @change="radioChange">
              <!--  -->
              <div class="card-trcekt-date">
                <el-radio :label="1">
                  <el-date-picker v-model="formInline.startTimeStr" type="datetime" placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                  至
                  <el-date-picker v-model="formInline.endTimeStr" type="datetime" placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm">
                  </el-date-picker>
                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="0">
                  领券当日起
                  <el-input v-model="formInline.receiveLimitDay" :max="999">
                  </el-input>
                  天内可用
                </el-radio>
              </div>
              <div class="card-trcekt-yxq">
                <el-radio :label="2">
                  长期有效
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discountContent"
          v-if="formInline.ticketType == 1 || formInline.ticketType == 2">
          <el-input type="textarea" placeholder="200字以内，建议写明卡券对应的服务内容" v-model="formdiscountContent"
            :autosize="{ minRows: 3, maxRows: 6 }" maxlength="200" @input="descInput('conent')">
          </el-input>
          <span class="textareaYz">{{discountContent}}/200</span>
        </el-form-item>
        <el-form-item label="可兑换产品范围" prop="productId" v-if="formInline.ticketType != 2">
          <el-radio v-model="productionRadio" label="1">全部产品</el-radio>
          <el-radio v-model="productionRadio" label="2">指定产品</el-radio>
          <div v-show="productionRadio === '2'">
            <el-button type="text" @click="handleOpenDialog">选择产品</el-button>
          </div>
          <prize-product-dialog :dialog-visible="productDialog" :is-clear="isClear"
            @handleProductClose="handleCloseDialog" @handleChoosedProduct="handleChoosedProduct"></prize-product-dialog>
          <prize-product-table :productionRadio="productionRadio" :choosed-product-list="choosedProductList"
            @handleProductList="handleProductList"></prize-product-table>
        </el-form-item>
        <el-form-item label="代金券类型" prop="productId" v-if="formInline.ticketType == 3">
          <el-radio-group v-model="formInline.cashCouponType">
            <el-radio :label="1">随机金额代金券</el-radio>
            <el-radio :label="2">满减券</el-radio>
            <el-radio :label="3">折扣券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠内容" prop="discount" v-if="formInline.cashCouponType !== 1">
          <div class="faceValue-box">
            <span v-if="formInline.cashCouponType == 2">面值</span>
            <span v-else>打</span>
            <el-input :oninput="formInline.discount=formInline.discount.replace(/[^\d.]/g,'')"
              v-model="formInline.discount">
            </el-input>
            <span v-if="formInline.cashCouponType == 2">元</span>
            <span v-else>折</span>
          </div>
        </el-form-item>
        <el-form-item label="使用门槛" prop="threshold"
          v-if="formInline.cashCouponType == 2 || formInline.cashCouponType == 3">
          <div class="timeBox faceValue-box">
            <el-radio-group v-model="formInline.threshold">
              <el-radio :label="1">无使用门槛</el-radio>
              <el-radio :label="2">
                <span>满</span>
                <el-input :oninput="formInline.usingThreshold=formInline.usingThreshold.replace(/[^\d.]/g,'')"
                  v-model="formInline.usingThreshold"></el-input>
                <span>元使用</span>
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="优惠内容" v-if="formInline.ticketType == 3 && formInline.cashCouponType == 1" required>
          <div class="cashCoupon_style">
            <el-col :span="5">
              <span>范围内随机</span>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="discountStart">
                <el-input type="number" v-model="discountStart">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">至</div>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="discountEnd">
                <el-input type="number" v-model="discountEnd">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div style="text-align: center;">元</div>
            </el-col>
            <el-col :span="2">
              <i class="el-icon-question" @mouseenter="enter()" @mouseleave="leave()"></i>
            </el-col>
            <div class="cashCoupon_ts" id="cashCoupon_ts">前后金额一致则为固定金额</div>
          </div>
        </el-form-item>
        <!-- <el-form-item label="核销操作："
                      prop="">
          <div class="card-hxSelect"
               v-for="(item, index) in hxList"
               :key="index">
            <el-select v-model="item.activityType"
                       placeholder="请选择受众"
                       @change="szChange">
              <el-option v-for="item in szOptions"
                         :key="item.modelId"
                         :label="item.modelName"
                         :value="item.modelId">
              </el-option>
            </el-select>
            <el-select v-model="item.qzType"
                       placeholder="请选择群组">
              <el-option v-for="items in qzOptions"
                         :key="items.groupId"
                         :label="items.groupName"
                         :value="items.groupId">
              </el-option>
            </el-select>
            <div class="remove-btn-quota"
                 style="float: right;margin: 0 20px 0 10px;cursor: pointer"
                 @click="removeDimensionItem(item, index)">
              <i class="el-icon-error"
                 title="删除当前条件"
                 style="color: #ccc;font-size: 15px"></i>
            </div>
          </div>
          <div class="card-sz"
               @click="addAnalyseDimension">
            <i class="el-icon-circle-plus"
               style="color: #1890ff;"></i>
            <div class="op-link"
                 style="margin: 0;font-size: 14px">增加受众</div>
          </div>
        </el-form-item> -->
        <el-form-item label="核销操作" prop="">
          <el-select v-model="formInline.relateAudienceObject.modelId" clearable placeholder="请选择受众" @change="szChange">
            <el-option v-for="item in szOptions" :key="item.modelId" :label="item.modelName" :value="item.modelId">
            </el-option>
          </el-select>
          <div style="max-height: 90px; overflow-y:auto ;margin-top:15px;">
            <!-- @click.native="szChange"  :remote-method=""-->
            <el-select filterable remote multiple v-model="qzValue" placeholder="请选择群组">
              <el-option v-for="items in qzOptions" :key="items.groupId" :label="items.groupName"
                :value="items.groupId">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="使用说明" prop="useExplain">
          <el-input type="textarea" placeholder="500字以内" v-model="formInlineuseExplain" maxlength="500"
            :autosize="{ minRows: 3, maxRows: 6 }" @input="descInput('explain')">
          </el-input>
          <span class="textareaYz">{{remnant}}/500</span>
        </el-form-item>
        <el-form-item>
          <div class="card-submit">
            <el-button type="primary" @click="submitForm">保存</el-button>
          </div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getModelList, getModelGroupList, sbmitTemplate, getProductList, } from '@/api/cardTicket.js'
import { CARD_TYPE, PRODUCT_RADIO } from './constant.js'
import prizeProductDialog from './components/prize-product-dialog.vue'
import prizeProductTable from './components/prize-product-table.vue'
export default {
  data () {
    var checkStar = (rule, value, callback) => {
      if (String(value).indexOf('.') > -1) {
        if (value.toString().split('.')[1].length > 2) {
          callback(new Error('优惠券面值必须是两位小数！'))
        } else if (value > 10000) {
          callback(new Error('优惠券面值不得超过10000元!'))
        }
      } else if (value <= 0) {
        callback(new Error('优惠券面值必须大于等于 0.01 元!'))
      } else if (value > 10000) {
        callback(new Error('优惠券面值不得超过10000元!'))
      } else {
        callback()
      }
    }
    var discount = (rule, value, callback) => {
      if (value) {
        if (this.formInline.cashCouponType == 3) {
          if (!/^\d+(\.\d{1,1})?$/.test(value)) {
            callback(new Error('最多输入一位小数'))
          } else if (value > 10 || value < 0) {
            callback(new Error('折扣券优惠内容必须介于0到10之间！'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('请填写优惠内容'))
      }
    }
    return {
      ticketNameLength: 30, // 卡券名称长度
      isClear: true, // 是否清空产品名称里已选择的列表
      productionRadio: '1', //  新增时默认 全部产品 ：1  指定产品：2
      productDialog: false, //选择产品的弹窗
      choosedProductList: [],// 弹窗中选择的产品列表
      formInline: {
        id: '',
        ticketType: 1,
        ticketName: '',
        isPeriodValidity: 1,
        startTimeStr: '',
        endTimeStr: '',
        receiveLimitDay: '',
        discountContent: '',
        useExplain: '',
        discountStart: '',
        discountEnd: '',
        relateAudienceObject:
        {
          modelId: '',
          groupIds: []
        },
        commoditys: [{
          code: '',
          name: ''
        }],
        cashCouponType: 1,//代金券类型
        faceValue: '',//面值
        threshold: 1,//使用门槛
        discount: '',//打折数
        usingThreshold: ''
      },
      productRelationArray: [],
      clickRelationArray: [],
      discountStart: '',
      discountEnd: '',
      formInlineuseExplain: '',
      formdiscountContent: '',
      ticketName: 0,
      discountContent: 0,
      remnant: 0,
      activityTypeOptions: {},
      cardType: '',
      cardTypeOptions: CARD_TYPE(),
      szNames: '',
      szOptions: [],//受众列表
      qzValue: [],
      qzOptions: [],//群组列表
      qzParams: {
        modelId: ''
      },
      rules: {
        ticketType: [{
          required: true,
          message: '请选择卡券类型',
          trigger: 'blur'
        }],
        ticketName: [{
          required: true,
          message: '请输入卡券名称',
          trigger: 'blur'
        }],
        isPeriodValidity: [{
          required: true,
          message: '请设定有效期',
          trigger: 'blur'
        }],
        discountContent: [{
          required: true,
          message: '请输入优惠内容',
          trigger: 'blur'
        }],
        discountStart: [{
          required: true,
          validator: checkStar,
          trigger: 'blur'
        }],
        discountEnd: [{
          required: true,
          validator: checkStar,
          trigger: 'blur'
        }],
        useExplain: [{
          required: true,
          message: '请输入使用说明',
          trigger: 'blur'
        }],
        discount: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        fullReduction: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        faceValue: [{
          validator: discount,
          trigger: 'blur',
          required: true
        }],
        threshold: [{
          required: true,
          message: '请选择使用门槛',
          trigger: 'blur'
        }],
      },
      validityDate: '',
      radio: 1,
      input: '',
      analyseQuotaData: [
        {
          analyseQuota: ['customer', 'peopleNum', 'sum']
        }
      ],
      hxList: [{
        activityType: '',
        qzType: ''
      }],
      qzarr: [],
    }
  },
  components: {
    prizeProductDialog,
    prizeProductTable
  },
  watch: {
    formInlineuseExplain (newVal, oldVal) {
      this.formInline.useExplain = newVal
      this.$refs.yhContent.innerHTML = newVal.replace(/\n/g, '<br>')
    },
    formdiscountContent (newVal, oldVal) {
      this.formInline.discountContent = newVal
      this.$refs.yhtitle1.innerHTML = newVal.replace(/\n/g, '<br>')
    },
    discountStart (newVal, oldVal) {
      this.formInline.discountStart = newVal
      if (newVal == this.discountEnd) {
        this.$refs.yhtitle3.innerHTML = this.discountStart + '元代金券'
      } else {
        this.$refs.yhtitle3.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
      }
    },
    discountEnd (newVal, oldVal) {
      this.formInline.discountEnd = newVal
      if (newVal == this.discountStart) {
        this.$refs.yhtitle3.innerHTML = this.discountEnd + '元代金券'
      } else {
        this.$refs.yhtitle3.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
      }
    },
    // 监听代金券类型
    'formInline.cashCouponType' (newVal, oldVal) {
      if (newVal == 2) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，无门槛使用'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$nextTick(() => {
            this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
            this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
          })
        }
      } else if (newVal == 3) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，无门槛使用'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }
      } else {
        this.$refs.yhtitle3.innerHTML = this.formInline.discountStart + '-' + this.formInline.discountEnd + '元代金券'
      }
    },
    // 监听面值
    'formInline.faceValue' (newVal, oldVal) {
      if (this.formInline.threshold == 1) {
        this.$refs.yhtitle3.innerHTML = this.formInline.faceValue + '元代金券，无使用门槛'
      } else {
        this.$refs.yhtitle3.innerHTML = this.formInline.faceValue + '元满减券，满' + this.formInline.usingThreshold + '元使用'
      }
    },
    // 监听使用门槛
    'formInline.threshold' (newVal, oldVal) {
      if (this.formInline.cashCouponType == 2) {
        if (this.formInline.threshold == 1) {
          this.$nextTick(() => {
            this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，无使用门槛'
            this.$refs.syms.innerHTML = '无使用门槛'
          })
        } else {
          this.$nextTick(() => {
            this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
            this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
          })
        }
      } else if (this.formInline.cashCouponType == 3) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，无使用门槛'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }

      }
    },
    // 监听使用门槛的钱数
    'formInline.usingThreshold' (newVal, oldVal) {
      if (this.formInline.cashCouponType == 2) {
        if (this.formInline.threshold == 1) {
          this.$nextTick(() => {
            this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，无使用门槛'
            this.$refs.syms.innerHTML = '无使用门槛'
          })
        } else {
          this.$nextTick(() => {
            this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
            this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
          })
        }
      } else if (this.formInline.cashCouponType == 3) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，无使用门槛'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }

      }
    },
    // 监听打折数
    'formInline.discount' (newVal, oldVal) {
      if (this.formInline.cashCouponType == 2) {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，无门槛使用'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '元满减券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }
      } else {
        if (this.formInline.threshold == 1) {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，无门槛使用'
          this.$refs.syms.innerHTML = '无使用门槛'
        } else {
          this.$refs.yhtitle3.innerHTML = this.formInline.discount + '折代金券，满' + this.formInline.usingThreshold + '元使用'
          this.$refs.syms.innerHTML = '满' + this.formInline.usingThreshold + '元使用'
        }
      }
    }
  },
  methods: {
    // 处理最终的产品列表
    handleProductList (list) {
      this.choosedProductList = list
    },

    // 处理已经选择的产品
    handleChoosedProduct () {
      const { multipleSelectionAll: list } = this.$store.state
      this.$nextTick(() => {
        this.choosedProductList = list
      })
      // 关闭弹窗
      this.productDialog = false
    },

    // 关闭弹窗
    handleCloseDialog () {
      this.productDialog = false
    },

    // 打开弹窗
    handleOpenDialog () {
      this.productDialog = true
    },

    leave () {
      document.getElementById('cashCoupon_ts').style.display = 'none'
    },
    enter () {
      document.getElementById('cashCoupon_ts').style.display = 'block'
    },
    changeType (val) {
      if (val === 1 || val === 2) {
        this.formInline.discountStart = ''
        this.formInline.discountEnd = ''
        this.discountStart = ''
        this.discountEnd = ''
      } else if (val === 3) {
        this.formInline.productId = ''
        this.qzarr = [{
          code: '',
          name: ''
        }]
      }
    },
    //搜索时查询产品名称
    remoteProductMethod (query) {
      if (query !== '') {
        let data = {
          page: 1,
          limit: 10,
          value: query,
          activityId: ''
        }
        getProductList(data).then(res => {
          if (res.data.code == '200') {
            let result = res.data.result.list
            this.productRelationArray = result
            for (let i = 0; i < result.length; i++) {
              this.clickRelationArray.push(result[i])
            }
          }
        })
      } else {
        //	this.productRelationArray = []
      }
    },
    //点击时查询产品名称
    getMyProductOptions () {
      let data = {
        page: 1,
        limit: 10,
        value: '',
        activityId: ''
      }
      getProductList(data).then(res => {
        if (res.data.code == '200') {
          let result = res.data.result.list
          this.productRelationArray = result
          for (let i = 0; i < result.length; i++) {
            this.clickRelationArray.push(result[i])
          }
        }
      })
    },
    changeProduct (value) {
      this.qzarr = []
      for (let i of value) {
        for (let item of this.productRelationArray) {
          if (i === item.productCode) {
            this.qzarr.push({
              code: i,
              name: item.productName
            })
          }
        }
      }
    },
    descInput (type) {
      if (type == 'name') {
        let ticketName = this.formInline.ticketName.length
        this.ticketName = this.ticketNameLength - ticketName
      } else if (type == 'conent') {
        let discountContent = this.formdiscountContent.length
        this.discountContent = 200 - discountContent
      } else {
        let txtVal = this.formInlineuseExplain.length
        this.remnant = 500 - txtVal
      }
    },
    // 查询受众列表
    getSzList () {
      getModelList().then(res => {
        this.szOptions = res.data.result
      })
    },
    // 选择受众时查询群组列表
    szChange (val) {
      if (val == '') {
        this.qzValue = []
      }
      this.qzParams.modelId = val
      this.getQZList()
    },
    getQZList () {
      getModelGroupList(this.qzParams).then(res => {
        this.qzOptions = res.data.result
      })
    },
    //增加受众
    addAnalyseDimension () {
      this.hxList.push({
        activityType: '',
        qzType: ''
      })
    },
    //删除受众
    removeDimensionItem (two, j) {
      // if (this.hxList.length === 1) {
      //   return
      // }
      this.hxList.splice(j, 1)
    },
    // 有效期的规则设定
    radioChange (val) {
      this.formInline.isPeriodValidity = val
      if (val == 1) {
        this.formInline.receiveLimitDay = ''
      } else if (val == 0) {
        this.formInline.startTimeStr = ''
        this.formInline.endTimeStr = ''
      } else {
        this.formInline.receiveLimitDay = ''
        this.formInline.startTimeStr = ''
        this.formInline.endTimeStr = ''
      }
    },
    //新增卡券模板
    submitForm () {
      if (this.formInline.cashCouponType == 3) {
        if (this.formInline.discount > 10 || this.formInline.discount < 0) {
          this.$message.error('优惠内容必须介于0到10之间！')
          return
        }
        if (!/^\d+(\.\d{1,1})?$/.test(this.formInline.discount)) {
          this.$message.error('优惠内容最多输入一位小数！')
          return
        }
      }
      if (this.formInline.threshold == 1) {
        this.formInline.usingThreshold = ''
      }
      // if (this.qzarr.length != 0) {
      //   this.formInline.commoditys = this.qzarr
      // } else {
      //   this.formInline.commoditys = [{
      //     code: '',
      //     name: ''
      //   }]
      // }

      // 判断一下 选择的是指定产品还是全部产品
      let product = []
      // 选择指定产品
      if (this.productionRadio === PRODUCT_RADIO['appoint']) {
        // 只选择了指定产品  但是没有选产品  要做一下判断
        if (this.choosedProductList.length === 0) {
          this.$message({
            message: '请选择指定产品',
            type: 'warning'
          })
          return
        }
        // 过滤 choosedProductList 只要以下三个字段
        product = this.choosedProductList.map(item => {
          return {
            name: item.productName,
            code: item.productCode
          }
        })

      }
      this.formInline.commoditys = product

      if (this.validityDate == null) {
        this.formInline.startTimeStr = ''
        this.formInline.endTimeStr = ''
      } else {
        this.formInline.startTimeStr = this.formInline.startTimeStr + ':00'
        this.formInline.endTimeStr = this.formInline.endTimeStr + ':00'
      }
      this.formInline.relateAudienceObject.groupIds = this.qzValue
      sbmitTemplate(this.formInline).then(res => {
        if (res.data.code == 200) {
          _g.toastMsg('success', '添加成功')
          this.isClear = false // 是否清空vuex里面存的产品名称的已选择的列表
          router.push('/home/card-ticket-module')
        } else {
          _g.toastMsg('error', res.data.message)
        }
      })
    }
  },
  mounted () {
    //获取受众列表
    this.getSzList()
    // this.getMyProductOptions()
  }
}
</script>

<style scoped>
.card-hxSelect {
  margin-bottom: 10px;
}
</style>